import { render, staticRenderFns } from "./CustomMetadataTeamSelector.vue?vue&type=template&id=0da8da33&lang=pug"
import script from "./CustomMetadataTeamSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomMetadataTeamSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports